// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7b7fd70c","553":"5310e1cd"}[chunkId] + ".chunk.js";
};